import { Card, Typography, Steps, Row, Col, List, Carousel } from 'antd';
import React, { useState } from 'react';
import Image1 from './Images/RabbitHoles-reduced.jpg';
import Image2 from './Images/UserInterests-reduced.jpg';
import Image3 from './Images/LongTermEffects-reduced.jpg';
import { LockTwoTone, EyeInvisibleTwoTone, HourglassTwoTone, MoneyCollectTwoTone, ControlTwoTone, QuestionCircleTwoTone} from '@ant-design/icons';
import './App.css'
import { Alert } from 'antd';

const { Text, Link, Title } = Typography;
const Step = Steps.Step;

const mpiBlue = "#5497CC"

const mainString = "We are asking people to donate their social media platforms data to shed light into the above mentioned questions. \
We will analyze the donated data in order to understand content recommendations made by the recommendation systems of social media platforms. \
We aim to understand and assess whether these recommendation systems push users towards extreme content (e.g., extremist/hateful content, fake news, etc.). \
We also seek to understand how recommendation algorithms affect users' interaction habits and whether they cause people discovering new interests. \
Studying these problems is extremely hard without comprehensive and rich datasets, which nowadays are only available to the companies themselves (i.e., Google and Bytedance). \
With your help via your donations, you will enable us to study these problems and further improve our lives!";

export const PageHome = () => {

    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });

    const [useMobileVersion, setUseMobileVersion] = useState(window.innerWidth <= 768);
    React.useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
            setUseMobileVersion(window.innerWidth <= 768);
        }

        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)

        }
    })

    const stepperCard = () => {
        return (
            <Card className={useMobileVersion ? "StepperCardMobile" : "StepperCard"}>
                <Card.Meta
                    title={<Text>Contribute to our research by following the steps below</Text>}
                    description={<Steps className="InstructionStepper" labelPlacement="vertical" responsive>
                        <Step
                            title={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Request your data"}</div>}
                            description={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>
                                {"Follow our guide to request your data from "}
                                <Link href="/guide/tiktok" target="_self">
                                    TikTok
                                </Link>
                                {", "}
                                <Link href="/guide/youtube" target="_self">
                                    YouTube
                                </Link>
                                {" or "}
                                <Link href="/guide/instagram" target="_self">
                                    Instagram
                                </Link>                                
                                {"."}
                            </div>}
                            status="process"
                            className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"} />
                        <Step
                            title={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Donate your data"}</div>}
                            description={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>
                                {"Donate your data through our "}
                                <Link href="/donate" target="_self">
                                    data donation page
                                </Link>
                                {", which allows you to choose which parts of your data you wish to donate, and anonymizes your data before it is transferred to our infrastructure."}
                            </div>}
                            status="process"
                            className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"} />
                        <Step
                            title={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Complete our survey"}</div>}
                            description={<div className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"}>{"Once you have donated your data, you will be directed to a short (optional) survey related to demographics and use of social media platforms."}</div>}
                            status="process"
                            className={useMobileVersion ? "InstructionStepMobile" : "InstructionStep"} />
                    </Steps>} />
            </Card>
        );
    };

    const images = () => {
        const text1 = "Do recommendation systems of social media platforms send you down information rabbit holes (i.e., recommending more extreme content over time)?";
        const text2 = "How do social media platforms shape your interests over time?";
        const text3 = "What are the long term effects of using social media platforms?";
        if (useMobileVersion) {
            return (
                < Carousel autoplay >
                    <div>
                    <Card cover={<img src={Image1} />}>{text1}</Card>
                    </div>
                    <div>
                    <Card cover={<img src={Image2} />}>{text2}</Card>
                    </div>
                    <div>
                    <Card cover={<img src={Image3} />}>{text3}</Card>
                    </div>
                </Carousel >);
        }
        else {
            return (
                <Row type="flex">
                    <Col>
                    <Card className="HomeImageLeft" cover={<img src={Image1} />}>{text1}</Card>
                    </Col>
                    <Col>
                    <Card className="HomeImageCenterRight" cover={<img src={Image2} />}>{text2}</Card>
                    </Col>
                    <Col>
                    <Card className="HomeImageCenterRight" cover={<img src={Image3} />}>{text3}</Card>
                    </Col>
                </Row>
            );
        }
    }

    const textBoxes = () => {
        return (
            <Row type="flex" className="BottomMargin">
                <Col>
                    <Card
                        className={useMobileVersion ? "MainHomeCardMobile" : "MainHomeCard"}>
                        {mainString}
                    </Card>
                </Col>
                <Col>
                    <Card
                        className={useMobileVersion ? "FeaturesCardMobile" : "FeaturesCard"}
                        itemLayout="horizontal">
                        <List>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<EyeInvisibleTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="All donated data will be anonymized before it is transferred to our infrastructure."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<LockTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="Donated data will be used for research purposes only and the data will not shared with any third parties. All publications from our project will only report aggregate results."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<HourglassTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="All donated data will be deleted from our infrastructure within 3 years after the end of our project."
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<ControlTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="You are in full control of what parts of the data to donate!"
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<MoneyCollectTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description="Earn up to $25!"
                                />
                            </List.Item>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<QuestionCircleTwoTone className="HomeIcon" twoToneColor={mpiBlue} />}
                                    description = "Do you have questions? Contact us at smousavi@mpi-sws.org"
                                />
                            </List.Item>



                        </List>
                    </Card>
                </Col>
            </Row>
        );
    }

    const title = () => {
        const new_title = 'Help researchers understand social media platforms by donating your data!';
        return (new_title)
    }

    return (
        <div>
            <Title className="Title" level={2}>
                {title()}
            </Title>
            {images()}
            {textBoxes()}
            {stepperCard()}
        </div>
    );
}

export default PageHome;
